import React, { useState } from "react";
import "../../styles/ChartCard.css"; // Optional, adjust as needed

export default function ChartCard({ title, children, dropdownOptions }) {
  const [selectedOption, setSelectedOption] = useState(
    dropdownOptions?.[0] || ""
  );

  return (
    <div className="chart-card">
      <div className="chart-card-header">
        <strong>{title}</strong>
        {dropdownOptions && (
          <select
            className="chart-dropdown"
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
          >
            {dropdownOptions.map((option, idx) => (
              <option key={idx} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}
      </div>
      <div className="chart-card-body">{children}</div>
    </div>
  );
}

  